import { AuthApi } from "../../Api";
import { getUserInfo } from "./getUserInfo";

import {
  SAVE_PROFILE_REQUEST,
  SAVE_PROFILE_SUCCESS,
  SAVE_PROFILE_FAILURE
} from "../../Constants";

function saveProfileInfo() {
  return {
    type: SAVE_PROFILE_REQUEST,
    isFetching: true
  };
}

function saveProfileSuccess(message) {
  return {
    type: SAVE_PROFILE_SUCCESS,
    isFetching: false,
    message
  };
}

function saveProfileError(errorMessage) {
  return {
    type: SAVE_PROFILE_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const saveProfileInformation = payload => (dispatch, getState) => {
  dispatch(saveProfileInfo());
  AuthApi.saveProfileData(payload)
    .then(res => {
      dispatch(saveProfileSuccess(res));
      dispatch(getUserInfo({}));
    })
    .catch(err => dispatch(saveProfileError(err)));
};
